import React from "react";

import { StyledImage } from "./StyledImage";

export const Image = props => {
  const { url, alt } = props;

  return <StyledImage url={url} alt={alt} loading="lazy" {...props} />;
};
